export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7971.a708af6c.jpg";